export enum CoinLogTypeEnum {
  USE = 'USE',
  RECEIVE = 'RECEIVE',
}
